import { configs } from '../configs';
import { eventBus, streamHook } from './Streams';
import { setUpSocket } from './SocketObservable';
import {setEventOptions} from './EventStreams';
import moment from 'moment';

/**
 * Get races by master id
 * @param masterId
 * @returns {*}
 */
export function receiveAthlinksRacesByMasterId({ masterId }) {
  const streamId = `GetAthlinksRacesByMasterId-${masterId}`;
  const defaultMessage = {};
  if(!!parseInt(masterId)) {
    defaultMessage.isLoading = true;
    setUpSocket('AthlinksRacesByMasterId', `athlinks/MasterEvents/Api/${masterId}`, streamId, configs.longPollingTime,
      (msg) => {
        msg && msg.result &&
        setEventOptions(masterId, getEventRaces(msg.result.eventRaces));
        eventBus.publish(streamId, this.extractRaceCourses(msg));
      });
  }
  return streamHook(streamId, defaultMessage);
}

/**
 * Get races for aan event
 * @param events
 */
export function getEventRaces(events) {
  return events && events.map(({raceID, raceDate, eventCourses}) => ({
    id: raceID,
    date: raceDate,
    courses: eventCourses.map(({courseID, eventCourseID, courseName, coursePatternID, coursePattern}) => ({
      courseID, eventCourseID, courseName, coursePatternID, coursePattern
    }))
  }));
}


/**
 * Get division and splits by event id using sockets (using in filters)
 * @param eventId
 * @returns {*}
 */
export function receiveDivisionsAndSplitsByEventId({ eventId }) {
  const streamId = `GetDivisionsAndSplitsByEventId-${eventId}`;
  let defaultMessage = [];
  if(!!parseInt(eventId)) {
    defaultMessage = {isLoading: true};
    setUpSocket('DivisionsAndSplitsByEventId', `athlinks/Events/Race/Api/${eventId}/Divisions`, streamId, configs.longPollingTime,
      (msg) => {
        if(msg.Success && msg.Result) {
          const divisions = (msg.Result || {})._brackets;
          const splits = (msg.Result || {})._intervals;
          if (divisions && splits) {
            eventBus.publish(streamId, {divisions, splits})
          } else {
            eventBus.publish(streamId, []);
          }
        } else {
          eventBus.publish(streamId, []);
        }
      });
  }

  return streamHook(streamId, defaultMessage);
}

/**
 * Get courses using sockets
 * @param athlinksId
 * @returns {*}
 */
export function receiveAthlinksCourses({ athlinksId }) {
  const streamId = `GetAthlinksCourses-${athlinksId}`;
  let defaultMsg = {races: []};
  if(!!parseInt(athlinksId)) {
    defaultMsg = {isLoading: true};
    setUpSocket('AthlinksCourses', `athlinks/Events/Api/${athlinksId}/Courses`, streamId, configs.longPollingTime,
      (msg) => {
        if (msg.result) {
          let courseNames = msg.result.courses.map((course) => {
            return {
              raceName: course.name,
              courseId: course.courseId,
              eventCourseId: course.eventCourseID
            };
          });
          let sorted = courseNames.sort(
            (a, b) => a.raceName.localeCompare(b.raceName));
          eventBus.publish(streamId, {races: sorted});
        } else {
          eventBus.publish(streamId, {races: []});
        }
      }
    );
  }

  return streamHook(streamId, defaultMsg);
}

/**
 * Get courses from an race
 * @param msg
 * @returns {*}
 */
export function extractRaceCourses(msg) {
  if (msg.success && msg.result && msg.result.eventRaces) {
    const eventCourses = msg.result.eventRaces.map((race) => {
      if (race.eventCourses.length) {
        return race.eventCourses.map((course) => {
          const epoch = moment.utc(race.raceDate).toDate().getTime();
          return {
            courseId: course.courseID,
            eventCourseId: course.eventCourseID,
            eventId: race.raceID,
            eventName: race.raceName,
            masterId: race.masterEventID,
            meters: course.distUnit,
            raceName: course.courseName,
            raceDate: race.raceDate,
            utcRaceDate: epoch,
            startEpoch: (epoch / 1000)
          }
        })
      }
      else {
        const epoch = moment.utc(race.raceDate).toDate().getTime();
        return [{
          eventId: race.raceID,
          eventName: race.raceName,
          masterId: race.masterEventID,
          raceDate: race.raceDate,
          utcRaceDate: epoch,
          startEpoch: (epoch / 1000)
        }]
      }
      
    });
    return {
      races: [].concat.apply([], eventCourses)
    }
  }
  else { return {races: []} }
}

export const RaceStreams = {
  receiveAthlinksCourses,
  receiveAthlinksRacesByMasterId,
  receiveDivisionsAndSplitsByEventId,
  extractRaceCourses
};



/** WEBPACK FOOTER **
 ** ./data/RaceStreams.js
 **/